import { render } from "./splitBill.vue?vue&type=template&id=1b554185&scoped=true"
import script from "./splitBill.vue?vue&type=script&lang=js"
export * from "./splitBill.vue?vue&type=script&lang=js"

import "./splitBill.vue?vue&type=style&index=0&id=1b554185&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b554185"]])

export default __exports__